import { render } from "./TabPage.vue?vue&type=template&id=b2801ede&scoped=true&ts=true"
import script from "./TabPage.vue?vue&type=script&lang=ts"
export * from "./TabPage.vue?vue&type=script&lang=ts"

import "./TabPage.vue?vue&type=style&index=0&id=b2801ede&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2801ede"]])

export default __exports__